import { Flex, Heading, Text, Box } from '@chakra-ui/react';
import { FC } from 'react';

type AdminMenuItemProps = {
  title: string;
  description: string;
  path: string;
  onClick: (data: { path: string }) => void;
};

const AdminMenuItem: FC<AdminMenuItemProps> = ({
  title,
  description,
  onClick,
  path,
}) => {
  const handleClick = () => {
    onClick({
      path,
    });
  };
  return (
    <Box
      marginTop="10px"
      as="button"
      textAlign="left"
      bg="whiteAlpha.700"
      p="6"
      rounded="lg"
      boxShadow="md"
      transition="all .2s ease-in-out"
      _hover={{ pl: '10' }}
      _focus={{ pl: '10' }}
    >
      <Flex direction="column" onClick={handleClick}>
        <Heading as="h3" fontSize="lg">
          {title}
        </Heading>
        <Text fontSize="sm">{description}</Text>
      </Flex>
    </Box>
  );
};

export default AdminMenuItem;
